// src/pages/VerifyEmail.tsx
import React, { useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';
import { useLocation, Link } from 'react-router-dom';

const VerifyEmail: React.FC = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token');
  const [status, setStatus] = useState<'loading'|'ok'|'error'>('loading');
  const [msg, setMsg] = useState('Verifying…');

  // One-shot guard to avoid duplicate calls in any render quirk
  const calledRef = useRef(false);

  useEffect(() => {
    if (!token) { setStatus('error'); setMsg('Missing token.'); return; }
    if (calledRef.current) return;
    calledRef.current = true;

    (async () => {
      try {
        // Log the effective URL to debug baseURL/env issues
        const url = api.getUri({ url: '/user/verify', params: { token } });
        // eslint-disable-next-line no-console
        console.log('VerifyEmail → GET', url);

        const res = await api.get('/user/verify', { params: { token } });
        setMsg(res.data?.message || 'Email verified. You can login now.');
        setStatus('ok');
      } catch (e: any) {
        // If you see ERR_CANCELED here, it’s almost always browser/security cancel
        // (mixed content, redirect loops, or CORS mismatch).
        const text = e?.response?.data?.error || e?.message || 'Verification failed.';
        setMsg(text);
        setStatus('error');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md rounded-xl shadow p-8 text-center">
        <h1 className="text-2xl font-semibold mb-4">Verify Email</h1>
        <div className={`text-sm ${status==='error' ? 'text-red-600':'text-gray-700'}`}>{msg}</div>
        <div className="mt-6">
          <Link to="/login" className="inline-block bg-blue-600 text-white px-4 py-2 rounded">Go to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
